import { styled } from "prism-react";
import type { ComponentProps } from "react";

const StyledSvg = styled("svg", {
  color: "$accent-primary-base",
});

type LogoProps = ComponentProps<typeof StyledSvg>;

export const Logo: React.FC<LogoProps> = (props) => (
  <StyledSvg
    height="48"
    viewBox="0 0 49 48"
    width="49"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M49 0L0 6.14448e-07V48H49V0ZM43.9886 43.0909V4.90909H5.01136V43.0909H43.9886Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </StyledSvg>
);
